import { MiniSwiper } from 'global/components/swipers/MiniSwiper';
import _ from 'lodash';
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { _matchDisplayTypes } from '../matches/MatchContent';
import { MatchesDate } from '../matches/MatchesDate';
import { SectionDateHeader } from './SectionDateHeader';
import { SectionHeader } from './SectionHeader';
import { gEnums } from 'global/enums/globalEnums';
import { uniqueKey } from 'global/common/keys';
import { GotScore } from './GotScore';
import MatchSquares, { _msTypes } from '../matches/MatchSquares';
import CardSponsor from 'global/components/sem/cards/CardSponsor';
import { _sportSponsorTypes } from 'projectSpecific/sports/useHelpers/useSportsSponsor';
import { _matchLsTypes } from 'projectSpecific/sports/helpers/sportsEnums';

const sponsorEvery = 5
const _allowSponsor = false

export const LevelSchedule = ({ teamKey }) => {

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { matches_info, details_info, teams_info } = sportsSeason_state ?? {}
  // const { teams } = teams_info ?? {}
  const { matches_groupInfo, matches_combined } = matches_info ?? {}
  const { levelSectionDateMatches, levelDatePlayoffMatches } = matches_groupInfo ?? {}
  const _lsdms = _.omit(levelSectionDateMatches, [_matchLsTypes.Non, _matchLsTypes.nonDistrict, _matchLsTypes.nonSection])
  const { details } = details_info ?? {}
  const { hideScheduleTeams, showGotScores } = details ?? {}

  //   const ldms = {
  //     1A: {
  //       '01/01/2024': {
  //         section1: [{}, {}]
  //       }
  //     }
  //   }
  // }

  // console.log('_lsdms', _lsdms)

  const [activeKey, setActiveKey] = useState()
  // const [selectedTeam, setSelectedTeam] = useState()

  const handleActiveKey = (index, key) => setActiveKey(key)

  // const teamsDd = useMemo(() => {
  //   const oc = (item) => {
  //     setSelectedTeam(item)
  //   }
  //   if (!teams) return null;
  //   const _teams = _.sortBy(teams, 'name')
  //   const dds = <DropDownSquares
  //     // caption={'Team'}
  //     activeItem={selectedTeam}
  //     items={_teams}
  //     icon={'users'}
  //     onClick={oc}
  //   />
  //   return dds
  // }, [selectedTeam]);

  const levelItems = useMemo(() => {

    const _levelItems = []

    // loop the Levels
    _.forEach(_lsdms, (levelGroup, levelKey) => {
      const pldg = levelDatePlayoffMatches?.[levelKey]

      // playoffs schedule
      const divs_schedulePlayoff = <Level_PlayoffSchedule
        levelDateGroups={pldg}
        levelKey={levelKey}
        activeKey={activeKey}
      />

      // season schedule
      const divs_schedule = <Level_Schedule
        levelDateGroups={levelGroup}
        levelKey={levelKey}
        activeKey={activeKey}
      />

      _levelItems.push(
        {
          key: levelKey,
          caption: levelKey,
          content: <div className='level-matches' key={uniqueKey('ls', levelKey)}>
            {divs_schedule}
            {divs_schedulePlayoff}
          </div>
        }
      )
    })

    // add an item from teams
    const _level_items = _.sortBy(_levelItems, 'key').reverse()

    return _level_items

  }, [_lsdms, matches_combined, levelDatePlayoffMatches])

  const content_schedule_levelMatches = useMemo(() => {
    return <MiniSwiper
      includeButtons={true}
      swipeItems={levelItems}
      showButtons={true}
      handleActiveKey={handleActiveKey}
      topper={showGotScores && <GotScore />}
    />
  }, [levelSectionDateMatches, levelItems, activeKey])

  return content_schedule_levelMatches

}

const getClosestDateKey = (dateKeys) => {
  const today = new Date()
  today.setHours(0, 0, 0, 0)

  return _.minBy(dateKeys, dateKey => {
    const d = new Date(dateKey)
    return Math.abs(d - today)
  })
}

const parseMMDDYYYY = (str) => {
  const [m, d, y] = str.split('/')
  return new Date(+y, +m - 1, +d)
}

const Level_Schedule = ({ levelDateGroups, levelKey, activeKey }) => {

  const levelDateRef = useRef({})
  const hasScrolled = useRef({})

  const [showAllDates, setShowAllDates] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowAllDates(true)
    }, 25)
    return () => clearTimeout(timer)
  }, [levelKey])

  useEffect(() => {
    const ldr = levelDateRef.current?.[levelKey]
    if (!ldr || activeKey !== levelKey || hasScrolled.current?.[levelKey]) return
    hasScrolled.current[levelKey] = true
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        ldr.scrollIntoView({
          behavior: 'instant',   // 👈 NOT 'instant'
          block: 'start',
          alignToTop: true
        })
      })
    })
  }, [activeKey])

  const ldss = (levelGroup) => {
    return Object.keys(levelGroup)
      .sort((a, b) => parseMMDDYYYY(a) - parseMMDDYYYY(b))
  }

  const _levelGroupDates = ldss(levelDateGroups)
  // const dateKeys = Object.keys(levelDateGroups)
  const closestDateKey = getClosestDateKey(_levelGroupDates)
  const divs = []

  const datesToRender = showAllDates
    ? _levelGroupDates
    : [closestDateKey]

  _.forEach(datesToRender, (dateKey, index) => {

    const dateGroup = levelDateGroups[dateKey]

    const _dateGroup = _.fromPairs(
      _.sortBy(_.toPairs(dateGroup), ([key]) => {
        const lower = _.toLower(key);
        const isNon = _.startsWith(lower, 'non');
        return [isNon ? 1 : 0, lower];
      })
    );

    const attachRef = dateKey === closestDateKey

    const div_date = <SectionDateHeader
      levelKey={levelKey}
      startDate={dateKey}
      matches={_dateGroup}
      attachRef={attachRef}
      levelDateRef={levelDateRef}
    />

    const divs_group = []

    let _index = 0

    _.forEach(_dateGroup, (sectionMatches, sectionKey) => {

      const _sectionHeader = <SectionHeader
        sectionKey={sectionKey}
        levelKey={levelKey}
      />

      const _sectionMatches = <MatchesDate
        dateKey={dateKey}
        levelKey={levelKey}
        matchDisplayType={_matchDisplayTypes.levelMatches}
        matches={sectionMatches}
        matchScheduleDisplayType={gEnums.matchScheduleDisplayTypes.levelTabsFull}
        sectionKey={sectionKey}
      />
      const div_section = <div className='match-date-matches ls'>
        {_sectionHeader}
        {_sectionMatches}
      </div>


      divs_group.push(div_section)

      _index++

      if (_allowSponsor && (_index + 1) % sponsorEvery === 0) {
        divs_group.splice(1, 0, <CardSponsor
          sportSponsorType={_sportSponsorTypes.schedule}
        />)
      }

    })

    divs.push(<div className='match-date-wrapper'>
      {div_date}
      {divs_group}
    </div>)

  })

  return divs

}

const Level_PlayoffSchedule = ({ levelDateGroups, levelKey, activeKey }) => {

  if (!levelDateGroups) return;

  const levelDateRef = useRef({})
  const hasScrolled = useRef({})

  useEffect(() => {
    const ldr = levelDateRef.current?.[levelKey]
    if (!ldr || activeKey !== levelKey || hasScrolled.current?.[levelKey]) return
    hasScrolled.current[levelKey] = true
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        ldr.scrollIntoView({
          behavior: 'instant',   // 👈 NOT 'instant'
          block: 'start',
          alignToTop: true
        })
      })
    })
  }, [activeKey])



  const ldss = (levelGroup) => {
    return Object.keys(levelGroup)
      .sort((a, b) => parseMMDDYYYY(a) - parseMMDDYYYY(b))
  }

  const _levelGroupDates = ldss(levelDateGroups)
  const dateKeys = Object.keys(levelDateGroups)
  const closestDateKey = getClosestDateKey(dateKeys)
  const divs = []

  _.forEach(_levelGroupDates, (dateKey) => {

    const dateMatches = levelDateGroups[dateKey]

    const attachRef = dateKey === closestDateKey

    const div_date = <SectionDateHeader
      levelKey={levelKey}
      startDate={dateKey}
      matches={dateMatches}
      attachRef={attachRef}
      levelDateRef={levelDateRef}
    />

    const _levelMatches = <MatchesDate
      dateKey={dateKey}
      levelKey={levelKey}
      matchDisplayType={_matchDisplayTypes.levelMatches}
      matches={dateMatches}
      forPlayoffs={true}
      matchScheduleDisplayType={gEnums.matchScheduleDisplayTypes.levelTabsFull}
    />

    divs.push(<div className='match-date-wrapper'>
      {div_date}
      {_levelMatches}
    </div>)

  })

  return divs

}